import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postCreateStudentLogin(teamId: any) {
    const { apiPostCreateStudentLogin } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostCreateStudentLogin}${teamId}/`, { teamId });
}
